import moment from 'moment'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import ChangeInterviewer from './components/ChangeInterviewer'
import AddAskingSalary from './components/AddAskingSalary'
import ChangeVacancy from './components/ChangeVacancy'
import AddSchedule from './components/AddSchedule'
import UpdateStage from './components/UpdateStage'
import HeaderFilter from './components/HeadFilter'
import RejectApplicant from './components/RejectApplicant'
import WithdrawApplication from './components/WithdrawApplication'
import BulkRejectApplicants from './components/BulkRejectApplicants'
import BulkSendEmailReminders from './components/BulkSendEmailReminders'
import SendEmailReminders from './components/SendEmailReminders'
import AcceptApplicant from './components/AcceptApplicant'
import RequisitionListWrapper from './components/RequisitionListWrapper'
import ChangeInterviewLink from './components/ChangeInterviewLink'
import Heading from '../../../components/dashboard/Heading'
import DownloadCVModal from '../../../components/print-cv/DownloadCVModal'
import ApplicantDetailsModal from '../../../components/dashboard/TalentPool/ApplicantDetailsModal'
import SmartSearch from '../../../components/SmartSearch'
import EditApplicantDetails from './components/EditApplicantDetails'

import useFetch from '../../../hooks/useFetch'

import { setRecruiters } from '../../../store/actions/recruitersActions'

const Pipelines = () => {
  const dispatch = useDispatch()
  const { modal } = useSelector((state) => state.lists)

  const { data: recruiters } = useFetch('/users/all?userTypeId=[1,5]')

  useEffect(() => {
    if (recruiters) {
      dispatch(setRecruiters(recruiters?.resp))
    }
  }, [recruiters])

  return (
    <>
      {/* pipelines heading */}
      <Heading title="Pipelines" subTitle={moment().format('MMMM Do, YYYY')} />

      {/* pipelines filter, this is used to filter the table data */}
      <HeaderFilter />

      {/* pipelines list wrapper */}
      <RequisitionListWrapper />

      {/* modals */}
      {modal.includes('changeInterviewer') && <ChangeInterviewer />}
      {modal.includes('changeVacancy') && <ChangeVacancy />}
      {modal.includes('editSchedule') && <UpdateStage />}
      {modal.includes('addInterviewSchedule') && <AddSchedule />}
      {modal.includes('applicantDetails') && <ApplicantDetailsModal />}
      {modal.includes('rejectApplicants') && <RejectApplicant />}
      {modal.includes('withdrawApplication') && <WithdrawApplication />}
      {modal.includes('acceptApplicant') && <AcceptApplicant />}
      {modal.includes('changeInterviewLink') && <ChangeInterviewLink />}
      {modal.includes('addAskingSalary') && <AddAskingSalary />}
      {modal.includes('smartSearch') && <SmartSearch />}
      {modal.includes('sendEmailReminders') && <SendEmailReminders />}
      {modal.includes('editApplicantDetails') && <EditApplicantDetails />}

      {/* bulk action modals */}
      {['bulkMoveToTalentPool', 'bulkDeclineApplicants'].includes(modal) && (
        <BulkRejectApplicants />
      )}

      {['bulkSendEmailReminders'].includes(modal) && (
        <BulkSendEmailReminders useBulk={true} />
      )}

      <DownloadCVModal />
    </>
  )
}

export default Pipelines
